<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue';
import { TabsContent, type TabsContentProps } from 'reka-ui';
import { cn } from '@/lib/utils';
const props = defineProps<TabsContentProps & { class?: HTMLAttributes['class'] }>();
const forwarded = computed(() => {
  const { class: _class, ...rest } = props;
  return rest;
});
</script>

<template>
  <TabsContent
    v-bind="forwarded"
    :class="
      cn(
        'mt-4 min-w-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30',
        props.class
      )
    "
    ><slot
  /></TabsContent>
</template>
